import React from 'react';
import styles from './Score.module.css';
import star from '../assets/star.svg';

const Score = (props) => {

    let stars = null;
    let plays = null;
    if (props.plays) {
        stars = (<img src={star} alt='star' />);
        plays = 'plays';
    }

    return (
        <div className={[styles.score, styles[plays]].join(' ')}>
            {stars}
            <div className={[styles[props.team.id], styles.teamName].join(' ')}>
                {props.team.name}
            </div>
            <div className={styles.teamScore}>
                {props.team.score}
            </div>
        </div>
    );
}

export default Score;